import { createContext, useContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

const SecretsCountContext = createContext({
  count: 0,
  setCount: () => {},
});

export function SecretsCountProvider({ children }) {
  const [count, setCount] = useState(0);

  const value = useMemo(() => ({
    count,
    setCount,
  }), [count]);

  return (
    <SecretsCountContext.Provider value={value}>
      {children}
    </SecretsCountContext.Provider>
  );
}

SecretsCountProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useSecretsCount = () => useContext(SecretsCountContext); 